import { createFileRoute } from "@tanstack/react-router";
import { RoleDetailPage } from "@/components/roles/role-detail";
import { requirePermission } from "@/lib/casl/route-guards";

export const Route = createFileRoute("/_authenticated/roles/$roleId")({
  component: RoleDetailPage,
  beforeLoad: ({ context }) => {
    requirePermission(context.user, "read", "roles");
  },
});
